import { render, staticRenderFns } from "./AmbassadorsMenuBanner.vue?vue&type=template&id=cd82e35a&scoped=true"
import script from "./AmbassadorsMenuBanner.vue?vue&type=script&lang=js"
export * from "./AmbassadorsMenuBanner.vue?vue&type=script&lang=js"
import style0 from "./AmbassadorsMenuBanner.vue?vue&type=style&index=0&id=cd82e35a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd82e35a",
  null
  
)

export default component.exports